import { useState, useRef, useEffect } from "react";
import { useAuthStorage } from "../hooks/useAuthStorage";
import useBusinessStore from "../state/businessStore";
import { useNavigate } from "react-router-dom";
import io from "socket.io-client";

import NotificationButtonIcon from "../assets/icons/Notification.svg";
import "./NotificationsButton.scss";

const NotificationsButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [receiveNewMessage, setReceiveNewMessage] = useState(false);
  const selectRef = useRef(null);
  const { selectedBusiness, businessNotifications, updateBusinessNotifications } = useBusinessStore();
  const { getToken } = useAuthStorage();
  const token = getToken();
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  /****************************************************
   ****************** WebSockets **********************
   ****************************************************/
  const socketRef = useRef(null);

  //:: Establish socket connection
  const establishSocketConnection = (businessId) => {
    socketRef.current = io(`${import.meta.env.VITE_BASE_URL}/events`, {
      extraHeaders: { Authorization: `Bearer ${token}` },
    });

    // Event when the connection to the socket succeeds
    socketRef.current.on("connect", () => {});

    // Listen to incoming messages in real-time for the current business
    socketRef.current.on(businessId, (newMessage) => {
      if (newMessage.direction !== "outgoing") {
        updateBusinessNotifications(newMessage);
        setReceiveNewMessage(true);
        setNotifications((prevNotifications) => [...prevNotifications, newMessage]);
      }
    });

    // Event when connection to the socket is disconnected
    socketRef.current.on("disconnect", () => {});
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    if (token && selectedBusiness) {
      //Establishes connection to the socket server for the current business
      establishSocketConnection(selectedBusiness);
    }

    // Cleanup: Disconnects the socket when disassembling the component or changing business
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, [selectedBusiness]); // Execute only when the selected business changes

  return (
    <div className="notification__button__container" ref={selectRef}>
      {receiveNewMessage && <span className="notification__badge"></span>}
      <button
        onClick={() => {
          setIsOpen(!isOpen);
          setReceiveNewMessage(false);
        }}
        className="notification__button"
      >
        <img src={NotificationButtonIcon} alt="" />
      </button>
      {isOpen && (
        <div className="notification__dropdown">
          {businessNotifications.length === 0 ? (
            <p style={{ textAlign: "center" }}>No hay notificaciones</p>
          ) : (
            businessNotifications.map((notification, index) => {
              return (
                <div className="notification__content" key={index}>
                  <div className="notification__content__icon">{notification.customer_id}</div>
                  <div
                    onClick={() => {
                      notification.direction && navigate(`/inbox/${notification.customer_id}`);
                    }}
                  >
                    {notification.direction ? (
                      <>
                        <p className="notification__content__body">
                          <b>Nuevo mensaje de {notification.customer_id}</b>
                        </p>
                        <p className="notification__content__time">
                          {new Date(notification.createdAt).toLocaleDateString("es-VE", {
                            day: "numeric",
                            month: "short",
                          })}{" "}
                          •{" "}
                          {new Date(notification.createdAt).toLocaleTimeString("es-VE", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          })}{" "}
                          • Inbox
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="notification__content__body">
                          <b>
                            {notification.customer_id} se movio a {notification.step}
                          </b>
                        </p>
                        <p className="notification__content__time">
                          {new Date(notification.timestamp).toLocaleDateString("es-VE", {
                            day: "numeric",
                            month: "short",
                          })}{" "}
                          •{" "}
                          {new Date(notification.timestamp).toLocaleTimeString("es-VE", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          })}{" "}
                          • Funnel
                        </p>
                      </>
                    )}
                  </div>
                  {/* <span className="notification__content__new"></span> */}
                </div>
              );
            })
          )}
          {/* <div className="notification__content">
            <p className="notification__content__title">Funnel</p>
            <p className="notification__content__body">3 se movio a 4</p>
            <span className="notification__content__new"></span>
          </div>
          <div className="notification__content">
            <p className="notification__content__title">Inbox</p>
            <p className="notification__content__body">Nuevo mensaje de 4</p>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default NotificationsButton;
